import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { MessageCircle } from "lucide-react";

export function Footer() {
  const { openWhatsApp } = useSettings();
  const links = [
    { to: "/", label: "Início" },
    { to: "/dispositivos", label: "Dispositivos" },
    { to: "/aplicativos", label: "Aplicativos" },
    { to: "/videos", label: "Vídeos" },
    { to: "/faq", label: "Perguntas Frequentes" },
    { to: "/status", label: "Status" },
  ];
  return (
    <footer className="border-t border-slate-800/80 bg-[#0A0E15] mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <img src="/logo.png" alt="Club Infinity" className="h-11 w-11 object-contain" />
            <span className="font-extrabold text-lg">
              <span className="ci-gold-text">CLUB</span> <span className="ci-cyan-text">INFINITY</span>
            </span>
          </div>
          <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
            Central de Suporte — tutoriais rápidos, aplicativos oficiais e atendimento profissional para configurar seu streaming em qualquer dispositivo.
          </p>
        </div>
        <div>
          <h4 className="text-xs font-semibold uppercase tracking-widest text-amber-400 mb-4">Links rápidos</h4>
          <ul className="space-y-2.5">
            {links.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-gray-400 hover:text-cyan-300 text-sm transition-colors">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-semibold uppercase tracking-widest text-amber-400 mb-4">Precisa de ajuda?</h4>
          <p className="text-gray-400 text-sm mb-4">Fale com nossa equipe agora mesmo pelo WhatsApp oficial.</p>
          <button onClick={() => openWhatsApp("footer")} data-testid="footer-whatsapp-btn"
            className="ci-btn-wa inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-white font-semibold text-sm hover:brightness-110 transition">
            <MessageCircle className="w-4 h-4" /> FALAR NO WHATSAPP
          </button>
        </div>
      </div>
      <div className="border-t border-slate-800/80 py-6 text-center text-sm text-gray-500">
        Club Infinity — Central de Suporte · © 2026 Club Infinity. Todos os direitos reservados.
      </div>
    </footer>
  );
}
